import { c as _c } from "react/compiler-runtime";
import { FALLBACK_IMAGE_SM } from "@website/ui/lazy-image";
import { getImage } from "@website/utils/get-image";
import { ReserveGalleryPropertiesTypes } from "@website/widget/reserve-gallery/reserve-gallery.types";
import range from "lodash-es/range";
import toString from "lodash-es/toString";
import { useRouter } from "next/router";
export const useReserveGallery = t0 => {
  const $ = _c(32);
  const {
    title,
    gallery
  } = t0;
  const router = useRouter();
  const t1 = gallery?.[0];
  let isModalOpen;
  let setIsModalOpen;
  let t2;
  if ($[0] !== gallery || $[1] !== router || $[2] !== t1) {
    let t3;
    if ($[6] !== gallery) {
      t3 = index => ({
        image: {
          ...gallery?.[index],
          media: getImage({
            width: 590,
            height: 800,
            src: gallery?.[index]?.media
          })
        },
        className: "row-span-2"
      });
      $[6] = gallery;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    let t4;
    if ($[8] !== gallery) {
      t4 = index_0 => ({
        image: {
          ...gallery?.[index_0],
          media: getImage({
            width: 590,
            height: 392,
            src: gallery?.[index_0]?.media
          })
        },
        className: "bg-outline-thin h-[200px] w-[100%] object-cover md:h-[100%]"
      });
      $[8] = gallery;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    const map = {
      1: [{
        image: {
          ...t1,
          media: getImage({
            width: 1584,
            height: 870,
            src: gallery?.[0]?.media
          })
        },
        className: "relative col-span-4 row-span-2"
      }],
      2: [{
        image: {
          ...gallery?.[0],
          media: getImage({
            width: 1192,
            height: 800,
            src: gallery?.[0]?.media
          })
        },
        className: "relative col-span-2 row-span-2"
      }, {
        image: {
          ...gallery?.[1],
          media: getImage({
            width: 1192,
            height: 700,
            src: gallery?.[1]?.media
          })
        },
        className: "relative col-span-2 row-span-2"
      }],
      3: [{
        image: {
          ...gallery?.[0],
          media: getImage({
            width: 1192,
            height: 800,
            src: gallery?.[0]?.media
          })
        },
        className: "relative col-span-2 row-span-2"
      }, ...range(1, gallery?.length).map(t3)],
      4: [{
        image: {
          ...gallery?.[0],
          media: getImage({
            width: 1192,
            height: 800,
            src: gallery?.[0]?.media
          })
        },
        className: "relative col-span-2 row-span-2"
      }, {
        image: {
          ...gallery?.[1],
          media: getImage({
            width: 590,
            height: 392,
            src: gallery?.[1]?.media
          })
        },
        className: ""
      }, {
        image: {
          ...gallery?.[2],
          media: getImage({
            width: 590,
            height: 800,
            src: gallery?.[2]?.media
          })
        },
        className: "row-span-2"
      }, {
        image: {
          ...gallery?.[3],
          media: getImage({
            width: 590,
            height: 392,
            src: gallery?.[3]?.media
          })
        },
        className: ""
      }],
      default: [{
        image: {
          ...gallery?.[0],
          media: getImage({
            width: 800,
            height: 460,
            src: gallery?.[0]?.media
          })
        },
        className: "relative col-span-2 row-span-2"
      }, ...range(1, 5).map(t4)]
    };
    const t5 = router.query?.modal;
    let t6;
    if ($[10] !== t5) {
      t6 = toString(t5);
      $[10] = t5;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    isModalOpen = t6 === "gallery";
    let t7;
    if ($[12] !== router) {
      t7 = (status, item) => status ? router.push({
        pathname: router.pathname,
        query: {
          ...router.query,
          modal: "gallery",
          index: item
        }
      }, undefined, {
        shallow: true,
        scroll: false
      }) : router.back();
      $[12] = router;
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    setIsModalOpen = t7;
    t2 = map[(gallery?.length < 5 ? gallery?.length : "default") as keyof typeof map]?.map(t8 => {
      const {
        className,
        image
      } = t8;
      return {
        containerProps: {
          className,
          key: image?.id,
          onClick: setIsModalOpen.bind(null, true, toString(image?.id))
        },
        imageProps: {
          alt: image?.alt || image?.title,
          fallback: FALLBACK_IMAGE_SM.src,
          loading: "eager" as const,
          src: image?.media,
          title: image?.title
        }
      };
    });
    $[0] = gallery;
    $[1] = router;
    $[2] = t1;
    $[3] = isModalOpen;
    $[4] = setIsModalOpen;
    $[5] = t2;
  } else {
    isModalOpen = $[3];
    setIsModalOpen = $[4];
    t2 = $[5];
  }
  let t3;
  if ($[14] !== setIsModalOpen) {
    t3 = setIsModalOpen.bind(null, true);
    $[14] = setIsModalOpen;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  let t4;
  if ($[16] !== t3) {
    t4 = {
      color: "neutral" as const,
      size: "small" as const,
      onClick: t3
    };
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  let t5;
  if ($[18] !== setIsModalOpen) {
    t5 = setIsModalOpen.bind(null, false);
    $[18] = setIsModalOpen;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== gallery || $[21] !== isModalOpen || $[22] !== t5 || $[23] !== title) {
    t6 = {
      title,
      gallery,
      isModalOpen,
      onClose: t5
    };
    $[20] = gallery;
    $[21] = isModalOpen;
    $[22] = t5;
    $[23] = title;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  let t7;
  if ($[25] !== gallery) {
    t7 = {
      gallery
    };
    $[25] = gallery;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  let t8;
  if ($[27] !== t2 || $[28] !== t4 || $[29] !== t6 || $[30] !== t7) {
    t8 = {
      imagesProps: t2,
      moreProps: t4,
      detailProps: t6,
      singleProps: t7
    };
    $[27] = t2;
    $[28] = t4;
    $[29] = t6;
    $[30] = t7;
    $[31] = t8;
  } else {
    t8 = $[31];
  }
  return t8;
};